function ABPASSValidation() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/ABPASSPost.html" // your HTML file in public folder
          title="ABPASS Validaition"
          width="100%"
          height="900px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default ABPASSValidation;
